module.exports = __webpack_public_path__ + "img/c08_unitbowman_Normal_ua.44319082.webp";